import { render, staticRenderFns } from "./GraphDetail15.vue?vue&type=template&id=4ad8630c&scoped=true&"
import script from "./GraphDetail15.vue?vue&type=script&lang=js&"
export * from "./GraphDetail15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad8630c",
  null
  
)

export default component.exports